import { Observable } from 'rxjs'
import { UserProfile } from '../models/user-profile'
import { User } from '../models/user'
import { User_details } from '../models/user-details'
import { SecurityQuestion } from '../models/security-question-model'

export abstract class UserProfileGateway {
    abstract retrieveUserProfile(): Observable<UserProfile>

    abstract updateUserProfile(profileModel: User): Observable<User>

    abstract createUserProfile(profileModel: User): Observable<User>

    abstract updateResetPassword(password: string, id: number): Observable<Boolean>

    abstract updateEmail(email: string, profileId: number): Observable<Boolean>
    abstract updateCellphoneNo(CellphoneNo: string, profileId: number): Observable<Boolean>

    abstract updateUserChangePasswordAndSecurityChallenge(
        password: string,
        questionId: number,
        questionAnswer: string,
        profileId: number
    ): Observable<Boolean>

    abstract findUserProfileByProfileID(id: number): Observable<UserProfile>

    abstract updateAdminPersonalDetails(profileModel: User): Observable<User>

    abstract isPasswordCorrect(password: string, profileId: number): boolean

    abstract isPasswordCountCorrect(password: string, profileId: number): boolean

    abstract getSecurityQuestion(profileId: number): Observable<SecurityQuestion>

    abstract getSecurityQuestions(): Observable<SecurityQuestion[]>

    abstract getEcontractDetailsByOrgID(orgId: number): Observable<boolean>

    abstract getFailedLoginAttempts(userName: string, failedAttemptLimit: number): number

    abstract lockUserAccount(userName: string): void

    abstract userProfileSearch(userProfileName: string, userId: number): Observable<UserProfile>
    abstract getUserAllDetails(userProfileID: number, planyear: string): Observable<User_details>

    abstract GetPWurl(): Observable<string>

    abstract CheckUserLoginPath(): Observable<boolean>
}
